import { Badge } from "./index.style";

const TYPE_BADGES = {
    positive: {
        color: "var(--green)",
        border_color: "var(--green-mid)",
        bg: "var(--green-light)",
    },
    negative: {
        color: "var(--red)",
        border_color: "var(--red-mid)",
        bg: "var(--red-light)",
    },
    zero: {
        color: "var(--text-sec)",
        border_color: "var(--border)",
        bg: "var(--white)",
    },
};
/**
 * @typedef {Object} PropsType
 * @property {("zero"|"positive"|"negative")} status
 * @property {number} hourWorked
 *
 */
/**
 * HourlyBadge c'est le badge des heures.
 * @param {PropsType} props
 * @returns {ReactNode}
 */
const HourlyBadge = ({ hourWorked, status, $submited = false }) => {
    const { color, border_color, bg } = TYPE_BADGES[status];

    return (
        <Badge
            color={$submited ? "#242424" : color}
            bg={$submited ? "#F0F0F0" : bg}
            border_color={$submited ? "#D1D1D1" : border_color}
            content={hourWorked}
        >
            {hourWorked}
        </Badge>
    );
};

export default HourlyBadge;
